import { useEffect, useState } from 'react';

import { useBoxSize } from './use-box-size';

export const useElementHeight = (selector: string) => {
  const [height, setHeight] = useState<number>();
  const element = document.querySelector(selector);
  const boxSize = useBoxSize(element);

  useEffect(() => {
    if (boxSize?.blockSize) {
      setHeight(boxSize.blockSize);
    }
  }, [boxSize?.blockSize]);

  return height;
};

export default useElementHeight;
